/** Standard US date format used across the admin app (MM/DD/YYYY). */
export const DISPLAY_DATE_FORMAT = 'MM/DD/YYYY'
export const DISPLAY_DATE_PLACEHOLDER = 'MM/DD/YYYY'
export const MOMENT_DISPLAY_FORMAT = 'MM/DD/YYYY'
export const BOOTSTRAP_DATEPICKER_FORMAT = 'MM/dd/yyyy'
export const FLATPICKR_DATE_FORMAT = 'm/d/Y'
export const FLATPICKR_RANGE_DATE_FORMAT = 'm-d-Y'
export const API_DATE_FORMAT = 'YYYY-MM-DD'
export const US_DATE_REGEX = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/
